<template lang="pug">
el-card(:body-style='{ padding: "20px" }')
    .d-flex.align-items-center.justify-content-between.mb-2
        h2.mb-0 Dados da operação
        .visualizar-operacoes-cda-wa__dados--titulo-direita
            em.status(
                v-if='operacao.status',
                :class='definirClasseStatus(operacao.status)'
            ) {{ operacao.status }}
            BaseButton(
                title='Editar',
                v-if='permitirEditar',
                type='primary',
                icon='el-icon-edit',
                size='mini',
                circle,
                @click='$emit("mostrarModalEditarOperacao")'
            )

    .visualizar-operacoes-cda-wa__dados
        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Operação
            p {{ operacao.identificador || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Descrição da operação
            p {{ operacao.descricao || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Volume da operação
            p {{ operacao.volumeContratadoFormatado || '-' }}

        .visualizar-operacoes-cda-wa__dado(
            v-loading='buscandoOperacao',
            :class='classeCardAnalise'
        )
            .visualizar-operacoes-cda-wa__dado__titulo
                h3 Fornecedor
                BaseButton(size='mini'  @click='mostrarModalAnaliseFornecedor = true') Visualizar análise {{ resultadoAnalise }}

            p {{ operacao.fornecedorNome || '' }} ({{ operacao.fornecedorDocumento }})

    .visualizar-operacoes-cda-wa__dados
        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Safra
            p {{ operacao.safra || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Cultura
            p {{ operacao.cultura || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Data do contrato
            p {{ operacao.dataContrato || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Vencimento
            p {{ operacao.dataVencimento || '-' }}

    .visualizar-operacoes-cda-wa__dados
        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Observação
            p {{ operacao.observacao || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Valor
            p {{ operacao.valorFormatado || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Nome do armazém
            p {{ operacao.nomeArmazem || '-' }}

        .visualizar-operacoes-cda-wa__dado(v-loading='buscandoOperacao')
            h3 Documento do armazém
            p {{ operacao.documentoArmazem || '-' }}

        ModalResultadoDiagnosticoFornecedor(
            :mostrar='mostrarModalAnaliseFornecedor',
            :dados='dadosAnaliseFornecedor',
            @fechar='mostrarModalAnaliseFornecedor = false'
        )
    .row(v-if='operacao.possuiPrimeiraAnalise === true')
        .col-12.data-display
            div
                hr
                span.data-value
                    | {{ $t('mensagens.operacao.monitoramento.revisarAnaliseCdaWaTexto1') }}&nbsp;
                BaseButton.button-link(
                    type='text',
                    @click='downloadPrimeiraAnalise()'
                ) {{ $t('mensagens.operacao.monitoramento.revisarAnaliseTexto2') }}
</template>

<script>
import ModalResultadoDiagnosticoFornecedor from '@/components/operacao-cda-wa/ModalResultadoDiagnosticoFornecedor.vue';
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'VisualizarOperacaoCdaWaDados',

    components: {
        ModalResultadoDiagnosticoFornecedor,
        BaseButton
    },

    props: {
        operacao: {
            type: Object,
            required: true
        },

        buscandoOperacao: {
            type: Boolean,
            required: true
        },

        permitirEditar: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            classesCoresStatus: {
                Aprovado: 'status_aprovado',
                Reprovado: 'status_reprovado',
                Processado: 'status_processado',
                'Em processamento': 'status_em_processamento'
            },

            resultadoAnalise: '',
            classeCardAnalise: '',
            calssesBotaoAnalise: '',

            dadosAnaliseFornecedor: {},
            mostrarModalAnaliseFornecedor: false
        };
    },

    watch: {
        buscandoOperacao: function () {
            if (!this.buscandoOperacao) {
                this.montarInformacoesFornecedor();
            }
        }
    },

    methods: {
        montarInformacoesFornecedor() {
            const diagnostico = this.operacao.resultadoAnaliseFornecedor;

            this.dadosAnaliseFornecedor = {
                analise: JSON.parse(this.operacao.resultadoAnaliseFornecedor),
                nome: this.operacao.fornecedorNome,
                documento: this.operacao.fornecedorDocumento
            };

            if (diagnostico?.includes('"nivelAlerta":"ALTO"')) {
                this.resultadoAnalise = 'inconforme';
                this.classeCardAnalise = 'analise_restricao';

            } else if (diagnostico?.includes('"nivelAlerta":"MEDIO"')) {
                this.resultadoAnalise = 'alerta';
                this.classeCardAnalise = 'analise_alerta';

            } else if (diagnostico?.includes('"nivelAlerta":"BAIXO"')) {
                this.resultadoAnalise = 'conforme';
                this.classeCardAnalise = 'analise_conforme';
            }
        },

        definirClasseStatus(status) {
            return this.classesCoresStatus[status] || '';
        },

        async downloadPrimeiraAnalise() {
            try {
                await OperacaoCdaWaService.downloadPrimeiraAnalise(this.operacao.id);
                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.downloadAnaliseErro')
                });
            }
        }
    }
};
</script>

<style lang="scss">
.visualizar-operacoes-cda-wa__dados--titulo-direita {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}

.visualizar-operacoes-cda-wa__dados {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    .visualizar-operacoes-cda-wa__dado {
        background-color: var(--tag-gray-background);
        border-radius: 4px;
        margin-top: 8px;
        padding: 16px;
        width: 25%;

        h3 {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 5px;
        }

        p {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            margin-bottom: 0px;
        }
    }
}

.status_reprovado {
    background-color: #ed5c40 !important;
}

.status_aprovado {
    background-color: #7fed40 !important;
}

.status_em_processamento {
    background-color: #edeea7 !important;
}

.status_processado {
    background-color: #eae13a !important;
}

.analise_conforme {
    background-color: #7fed404b !important;
    border: 1px solid #7fed40 !important;
}

.analise_alerta {
    background-color: #eae13a4b !important;
    border: 1px solid #eae13a !important;
}

.analise_restricao {
    background-color: #ed5c404b !important;
    border: 1px solid #ed5c40 !important;
}

.visualizar-operacoes-cda-wa__dado__titulo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

.button-link {
    color: #1e90ff;
    text-decoration: underline;
}
</style>
